module.exports = __webpack_public_path__ + "img/dynamic-13.5d6aa561.png";